import styled from "styled-components";

const Card=styled.div`

background:#20263A;
color:#F8FAFC;
padding:22px;
border-radius:22px;

`;

const Bar=styled.div`

height:10px;
background:#22314c;
border-radius:999px;
overflow:hidden;

`;

const Fill = styled.div`

height:100%;

background:linear-gradient(

90deg,

#38BDF8,

#60A5FA

);

border-radius:999px;

`;

export default function CareerProjectionCard({

carreras

}){

return(

<Card>

<h2
style={{
margin:0,
color:"#F8FAFC"
}}
>

🎯 Potencial de ingreso

</h2>

{

carreras.map(carrera=>(

<div
key={carrera.nombre}
style={{
marginTop:20
}}
>

<div
style={{
display:"flex",
justifyContent:"space-between"
}}
>

<strong
style={{
color:"#F8FAFC"
}}
>

{carrera.nombre}

</strong>

<strong
style={{
color:"#38BDF8"
}}
>

{carrera.probabilidad}%

</strong>

</div>

<Bar>

<Fill
style={{
width:`${carrera.probabilidad}%`
}}
/>

</Bar>

</div>

))

}

</Card>

);

}